export default __webpack_public_path__ + "static/media/paint-jar.62714041.svg";